import { useCallback, useEffect, useRef } from 'react';
import {
  SetURLSearchParams,
  URLSearchParamsInit,
  createSearchParams,
  useSearchParams,
} from 'react-router-dom';

export default function useSearchParamsWithSetInit(
  defaultInit?: URLSearchParamsInit,
): [URLSearchParams, SetURLSearchParams] {
  const [searchParams, setSearchParams] = useSearchParams();
  const hasSetParams = useRef(false);
  const defaultSearchParams = useRef(createSearchParams(defaultInit));

  const setSearchParamsWithTracking: SetURLSearchParams = useCallback(
    (...args) => {
      hasSetParams.current = true;
      setSearchParams(...args);
    },
    [setSearchParams],
  );

  const hasDefaults = defaultSearchParams.current.toString().length > 0;
  const isEmpty = searchParams.toString().length === 0;

  useEffect(() => {
    if (!hasDefaults || !isEmpty || hasSetParams.current) return;
    setSearchParamsWithTracking(defaultSearchParams.current);
  }, [hasDefaults, isEmpty, setSearchParamsWithTracking]);

  return [searchParams, setSearchParamsWithTracking];
}
